import * as React from "react";
import { Stack } from "@mui/material";
import ETollChargesFilter from "../filters/ETollChargesFilter";
import ETollChargesTable from "../tables/ETollChargesTable";

function ETollCharges() {

    return (
        <Stack direction={"column"} spacing={2} margin={"16px"}>
            <ETollChargesFilter/>
            <ETollChargesTable/>
        </Stack>
    )
}

export default ETollCharges;